/**
 * The checks an item passes after its intake, by platform, in the order of specification §8:
 * the first failure in this order is the item's primary reason. Each check is decided
 * automatically or by a person, and an upheld issue may correct it (§10).
 *
 * The rules of §6 are all decided at intake for a YouTube video, so its items have no `rules`
 * check. Only YouTube items have the `media` and `format` checks.
 */

import type { Platform } from "./terms.js";

export const ITEM_CHECKS = {
  X: ["edits", "rules", "elements", "manipulation", "semantic", "visual", "fraud"],
  YOUTUBE: ["edits", "elements", "media", "format", "manipulation", "semantic", "visual", "fraud"],
} as const satisfies Record<Platform, readonly string[]>;

/** A check some platform's items pass. */
export type ItemCheckName = (typeof ITEM_CHECKS)[Platform][number];

/** The checks a platform's items pass, in order. */
export function itemChecksOf(platform: Platform): readonly ItemCheckName[] {
  return ITEM_CHECKS[platform];
}
